import { CategoryType } from "../../types/Category.ts";

export const EMPTY_CATEGORY: CategoryType = {
  _id: "",
  slug: "",
  name: "",
  subCategories: [], //string when foreign key is used //TODO: Use only foreign key?
  filters: [], // Flexible key-value pairs
};
